import React from "react";
import PropTypes from "prop-types";

const ImageLinkContainer = ({ path, url, name, className, type, avatar }) => {
  return (
    <a className={`u-${type}-base ${className}`} href={path} target="_blank">
      <img className={`u-image-center ${avatar && 'u-image-center--avatar'}`} src={url} alt={name} />
    </a>
  );
};

ImageLinkContainer.propTypes = {
  path: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  avatar: PropTypes.bool,
};

ImageLinkContainer.defaultProps = {
  path: "",
  url: "",
  name: "",
  className: "",
  type: "image",
  avatar: false,
};

export default ImageLinkContainer;
